import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { injectInterceptor } from "module/common/utils/axiosConfig";
import App from "./module/main/App/App";
import store from "module/main/store/store";
import { retrieveAndSetAuthToken } from "module/main/store/auth/utils";
import "./assets/styles/main.css";
if (process.env.NODE_ENV !== "development") {
    Sentry.init({
        dsn: "https://7c02c7bc4133d7f336825c7360965674@sentry.skipsherpa.com/6",
        integrations: [Sentry.browserTracingIntegration()],
        environment: process.env.NODE_ENV,
        release: "skipsherpa-frontend@".concat(process.env.REACT_APP_CURRENT_RELEASE),
        // Set tracesSampleRate to 1.0 to capture 100%, possibly update this in prod
        tracesSampleRate: 1.0,
    });
}
retrieveAndSetAuthToken();
injectInterceptor(store);
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(Provider, { store: store, children: _jsx(App, {}) }));
